<template>
    <div class="modal-wrapper" :class="{ hide: !modals.depositForArgentinaModal }" v-on:click.stop="hideModal">
        <div class="modal ElevationDark__3" v-on:click.stop>
            <div class="title">
                <span class="title__large">{{ tokens.newDesign.depositArgentinaModalTitle }}</span>
            </div>
            <span class="warning body__medium">
                {{ tokens.newDesign.depositArgentinaModalText }}
            </span>
            <div class="row actions">
                <BaseButton 
                    :button-style="'filled-primary'" 
                    :button-text="tokens.newDesign.depositArgentinaModalButton"
                    @click.native="hideModal()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import { MODAL } from '@/store/mutations.type'
import BaseButton from "@/new-design/shared/ui/buttons/BaseButton.vue";

export default {
    name: "CancelPositionModal",
    components: { BaseButton },
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                depositForArgentinaModal: false
            })
        },
    },
    computed: {
        ...mapGetters(['modals', 'tokens']),
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 360px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--System-Surface3);
    border-radius: var(--Corner-small);
    z-index: 1100;
}

.title {
    padding: 24px;
    color: var(--System-OnSurface);
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.warning {
    padding: 0 24px;
    color: var(--System-OnSurfaceVariant);
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
    gap: 8px;
}

.symbol-content {
    padding: 24px 24px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.price-info,
.symbol-info {
    display: flex;
    align-items: center;
}

.price-info {
    gap: 10px;
}

.symbol-info {
    gap: 12px;
}

.symbol {
    zoom: 0.4;
}

.alias,
.profit {
    color: var(--System-OnSurface);
}

.actions {
    justify-content: flex-end;
    padding: 24px;
    margin-top: 24px;
    border-top: 1px solid var(--System-OutlineVariant);
}

@keyframes l3 {
    to {
        transform: rotate(1turn)
    }
}

@keyframes l2 {
    to {
        transform: rotate(1turn)
    }
}
</style>
